import React, { useEffect, useState } from "react";
import Clienthomemenu from "../Menus/Clienthomemenu";
import Setftestexammodule from "./Setftestexammodule";
import Readingallquestion from "./Readingallquestion";

export default function Reading() {
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [topics, setTopics] = useState([]);

  const [questions, setQuestions] = useState([]);
  const [startExam, setStartExam] = useState(false);
  const [loading, setLoading] = useState(false);
  const [testid, setTestid] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));
  const LANGUAGE_ID = localStorage.getItem("language");
  const uid = user?.UID;

  /* ================= SUBJECT LIST ================= */
  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_SUBJECT}`;

      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          TRADE_ID: user?.TRADE_ID,
          TRADE_NAME: user?.TRADE_NAME,
        }),
      });

      const data = await res.json();

      if (data.res === "Success") {
        setSubjects(data.data);

        if (data.data.length > 0) {
          setSelectedSubject(data.data[0].TRADE_ID); // default first
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= LOAD TOPICS ON SUBJECT CHANGE ================= */
  useEffect(() => {
    if (selectedSubject) {
      fetchTopics(selectedSubject);
    }
  }, [selectedSubject]);

  const fetchTopics = async (tradeId) => {
    try {
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_TOPIC}`;

      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          TRADE_ID: tradeId, // ✅ IMPORTANT
        }),
      });

      const data = await res.json();

      if (data.res === "success") {
        setTopics(data.data);
      } else {
        setTopics([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= START EXAM ================= */
  const handleStartTest = (topic) => {
    setLoading(true);

    const payload = {
      TRADE_ID: selectedSubject,
      TOPIC_UID: topic.TOPIC_UID,
      NUM_OF_QUE: 1000000000,
      LANGUAGE_ID: LANGUAGE_ID,
    };

    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_QUESTION1}`;

    fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.res === "success") {
          setQuestions(data.data);
          setTestid(data.TEST_UID || "");
          setStartExam(true);
        } else {
          alert(data.msg || "No questions found");
        }
        setLoading(false);
      })
      .catch(() => {
        alert("Server error");
        setLoading(false);
      });
  };

  /* ================= OPEN EXAM ================= */
  if (startExam) {
    return (
      <Readingallquestion questions={questions} testid={testid} userid={uid} />
    );
  }

  return (
    <>
      <Clienthomemenu title="EasyITI" testhistory="testhistory" />

      <div className="container" style={{ height: "auto" , paddingTop: "90px",}}>
        {/* SUBJECT */}
        <label className="form-label">Select Subject</label>

        {subjects.length > 0 ? (
          <select
            className="form-select"
            value={selectedSubject}
            onChange={(e) => setSelectedSubject(e.target.value)}
          >
            {subjects.map((item) => (
              <option key={item.TRADE_ID} value={item.TRADE_ID}>
                {item.TRADE_NAME}
              </option>
            ))}
          </select>
        ) : (
          <div className="skeleton-dropdown"></div>
        )}

        {/* TOPICS */}
        <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div className="row mt-4">
            {topics.length > 0
              ? topics.map((topic) => (
                  <div className="col-md-4 mb-3" key={topic.TOPIC_UID}>
                    <div
                      className="card p-3 shadow-sm text-center topic-card"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleStartTest(topic)}
                    >
                      <h6>{topic.TOPIC_NAME}</h6>
                      <small>Click to start exam</small>
                    </div>
                  </div>
                ))
              : [...Array(6)].map((_, i) => (
                  <div className="col-md-4 mb-3" key={i}>
                    <div className="card p-3 shadow-sm">
                      <div className="skeleton-title"></div>
                      <div className="skeleton-text"></div>
                    </div>
                  </div>
                ))}
          </div>
        </div>

        {loading && (
          <div className="text-center mt-3">
            <div className="spinner-border text-primary" />
            <p>Loading exam...</p>
          </div>
        )}
      </div>
    </>
  );
}
